var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
export default class StateService {
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/states/search/findByNameContainingIgnoreCase", {
                params: { search, sort: "name", order: "ASC", size: 100 },
            });
            return response.data._embedded.states;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/states/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.states;
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getPagedResponse("/aviso/state/search", {
                ids: search.ids,
                acronyms: search.acronyms,
                names: search.names,
                regions: search.regions,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
        });
    }
}
